import Button from 'src/components/button/Button';
import { type MovieQuestionAnswerAlternative } from 'src/lib/movieinfo/movieinfotypes';
import styled from 'src/lib/styles/css';

//#region [Props]
type AnswerAlternativeProps = {
	answerAlternative: MovieQuestionAnswerAlternative;
	doCorrectAnswer: () => void;
	doWrongAnswer: () => void;
	isAnswered: boolean;
};
//#endregion

//#region [Component]
export default function AnswerAlternative({ answerAlternative, doCorrectAnswer, doWrongAnswer, isAnswered }: AnswerAlternativeProps) {
	const onClick = () => {
		if (answerAlternative.isCorrect) {
			doCorrectAnswer();
		} else {
			doWrongAnswer();
		}
	};

	return <SAnswerAlternativeButton disabled={isAnswered} onClick={onClick} text={answerAlternative.answerAlternative!} />;
}
//#endregion

//#region [Styles]
const SAnswerAlternativeButton = styled(Button)`
	max-width: 700px;
	cursor: pointer;
	color: var(--palette-lilla-mørk-hovedfarge);
	font-weight: bold;
	margin-bottom: 20px;
	font-size: 20px;
	margin-left: auto !important;
	margin-right: auto;
	display: flex;
	width: 100%;
	justify-content: center;
	background-color: var(--palette-turkis2);
	white-space: normal;

	@media (min-width: 550px) {
        /*@media  (orientation: landscape) {*/
        transition: transform 250ms;

        &:hover {
            transform: scale(1.1);
        }
    }
`;
//#endregion